import 'flag-icon-css/css/flag-icon.css';

import { ChallengeResult, closeChallengeDialog } from '../../../modules/challenge';
import { CircularProgress, TextField, Typography } from '@material-ui/core';
import { IStoreState, ThunkDispatch } from '../../../modules';
import React, { ChangeEvent, Component, FormEvent, Fragment } from 'react';
import { Theme, WithStyles, createStyles, withStyles } from '@material-ui/core/styles';
import { authenticate as soapAuthenticate, challenge as soapChallenge } from '../../../modules/api';

import Button from '@material-ui/core/Button';
import ChallengeRequestProps from './ChallengeRequestProps';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { PhoneNumberEnrolment } from '../../../components/PhoneNumberInput';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { enrolmentToContactList } from '../../../helpers/credentials/OobSms';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const styles = (theme: Theme) => createStyles({
  progress: {
    display: 'block',
    margin: `${theme.spacing(2)}px auto`,
  },
  dialogActions: {
    display: 'flex',
    flexDirection: 'row-reverse',
    justifyContent: 'space-between',
    alignItems: 'stretch',
  },
  error: {
    color: theme.palette.error.main
  },
  contactList: {
    maxWidth: theme.spacing(50),
    margin: `0 auto`,
  },
  contact: {
    cursor: 'pointer',
    padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
  },
  chevron: {
    marginLeft: theme.spacing(2),
  },
})

type State = {
  loading: boolean
  enrolments: PhoneNumberEnrolment[]
  selectedEnrolment: PhoneNumberEnrolment | null
  acspChallengeStatus: string
  otp: string
  error: string
};

class OobSmsChallengeRequest extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    let enrolments = this.props.authmethods.oobSms.enrolments

    this.state = {
      loading: true,
      enrolments,
      selectedEnrolment: null,
      acspChallengeStatus: "",
      otp: "",
      error: "",
    }
  }

  componentWillMount() {
    this.setState({ loading: false })
  }

  handleOtpChange(e: ChangeEvent<HTMLInputElement>) {
    this.setState({
      otp: e.target.value
    })
  }

  handleChallengeContact(pne: PhoneNumberEnrolment) {
    let args = {
      credentialChallengeRequestList: {
        acspChallengeRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBSMSChallengeRequest",
                xmlns: "http://ws.oobsms.csd.rsa.com"
              }
            },
            contactList: enrolmentToContactList(pne)[0]
          }
        }
      }
    }

    this.setState({
      selectedEnrolment: pne,
      loading: true,
    })
    this.props.soapChallenge(args).then((data: any) => {
      try {
        let callStatus = data.credentialChallengeList.acspChallengeResponseData.callStatus

        if (callStatus.statusCode !== "PENDING")
          throw new Error("Received response status code: " + callStatus.statusCode)

        this.setState({
          loading: false,
          acspChallengeStatus: callStatus.statusCode
        })
      } catch (error) {
        console.error(error)
        this.setState({ selectedEnrolment: null, loading: false, error: "Error sending challenge request" })
      }
    }).catch((error: Error) => {
      console.error(error)
      this.setState({ selectedEnrolment: null, loading: false, error: "Error sending challenge request" })
    })
  }

  handleAuthenticate = (e: FormEvent) => {
    e.preventDefault()

    const { otp } = this.state

    let args = {
      credentialDataList: {
        acspAuthenticationRequestData: {
          payload: {
            $attributes: {
              $xsiType: {
                type: "OOBSMSAuthenticationRequest",
                xmlns: "http://ws.oobsms.csd.rsa.com"
              }
            },
            otp
          }
        }
      }
    }
    this.props.soapAuthenticate(args)
      .then((data: any) => {
        if (data.credentialAuthResultList.acspAuthenticationResponseData.callStatus.statusCode === "SUCCESS") {
          this.props.challengeResponse(ChallengeResult.Success)
        }
        else {
          this.props.challengeResponse(ChallengeResult.Failure)
        }
      }).catch((error: Error) => {
        this.props.challengeResponse(ChallengeResult.Error)
      })
  }

  handleBack = () => {
    if (this.state.selectedEnrolment == null)
      this.props.challengeResponse(ChallengeResult.Pending)
    else {
      this.setState({ selectedEnrolment: null })
    }
  }

  maskedNumber = (pne: PhoneNumberEnrolment) => {
    let pn = pne.phoneNumber
    let maskedNumber = pn.getNumber('international')

    let extract = maskedNumber.match(/^\+?(\S+)(.*)((?:\d\D?){4})$/)

    if (extract && extract.length > 2)
      maskedNumber = extract[1] + extract[2].replace(/\d/gi, 'x') + extract[3]
    return maskedNumber
  }

  renderContact = (c: PhoneNumberEnrolment) => {
    const { classes } = this.props

    return (
      <ListItem key={c.key} className={classes.contact} button onClick={() => this.handleChallengeContact(c)}>
        <ListItemIcon>
          {
            <span className={classnames("flag-icon", c.phoneNumber.isValid() ? `flag-icon-${c.phoneNumber.getRegionCode().toLowerCase()}` : "flag-icon-hidden")}></span>
            /*<FontAwesomeIcon icon={faMobileAlt} fixedWidth size="2x" />*/
          }
        </ListItemIcon>
        <ListItemText inset primary={this.maskedNumber(c)} />
        <FontAwesomeIcon icon={faChevronRight} size="1x" className={classes.chevron} />
      </ListItem>
    )
  }
  render() {
    const { loading, error, enrolments, selectedEnrolment } = this.state
    const { classes } = this.props

    return (
      <Fragment>
        {loading && !error &&
          <CircularProgress className={classes.progress} />
        }

        {!loading && selectedEnrolment === null &&
          <Fragment>
            <DialogContent>
              <Typography className={classes.error}>{error}</Typography>
              <DialogContentText>
                Select a phone number to receive your OTP on:
              </DialogContentText>
              <List className={classes.contactList}>
                {enrolments.map(this.renderContact)}
              </List>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <div></div>
              <Button onClick={this.handleBack} color="default">
                Back
              </Button>
            </DialogActions>
          </Fragment>
        }

        {!loading && selectedEnrolment !== null &&
          <Fragment>
            <DialogContent>
              <Typography className={classes.error}>{error}</Typography>
              <DialogContentText>
                Enter the OTP sent to {this.maskedNumber(selectedEnrolment)}
              </DialogContentText>
              <form onSubmit={this.handleAuthenticate}>
                <TextField
                  autoFocus
                  margin="dense"
                  id="otp"
                  label="OTP"
                  type="text"
                  onChange={this.handleOtpChange.bind(this)}
                  fullWidth
                />
              </form>
            </DialogContent>
            <DialogActions className={classes.dialogActions}>
              <Button onClick={this.handleAuthenticate} color="primary">
                Authenticate
              </Button>
              <Button onClick={this.handleBack} color="default">
                Back
              </Button>
            </DialogActions>
          </Fragment>
        }
      </Fragment>
    )
  }
}


const mapStateToProps = ({ auth, authmethods, challenge }: IStoreState) => ({
  auth,
  authmethods,
  challenge
})

const mapDispatchToProps = (dispatch: ThunkDispatch) =>
  bindActionCreators(
    {
      soapChallenge,
      soapAuthenticate,
      closeChallengeDialog
    }, dispatch
  )

interface Props extends WithStyles<typeof styles>, ReturnType<typeof mapStateToProps>, ReturnType<typeof mapDispatchToProps>, ChallengeRequestProps {
  // refer to ChallengeRequestProps.ts
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(OobSmsChallengeRequest));